import React, { useState } from 'react';
import SettingsTab from "components/__new/settings/tab";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ReactComponent as IconPlus } from "assets/images/icons/project-icons/Plus.svg";
import { ReactComponent as IconInformationOutline } from "assets/images/icons/project-icons/information-outline.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { Checkbox, Input, SelectInput } from "components/__new/common/form";
import { BackButtonPage } from "components/__new/common/BackButton";
import ReactToolTip from "react-tooltip";
import FormDrawer from "components/__new/common/form-drawer";
import useBackButton from "hooks/useBackButton";
import Maybe from "components/__new/common/Maybe";


const Form = () => {
    const {goBack} = useBackButton();
    const [isOpenStepsApproval, setIsOpenStepsApproval] = useState({
        isOpen: false,
        type: "",
    });


    const [form, setForm] = useState({
        name: "",
        type: "",
        initiators: [],
        collaborators: [],
        approvers: [],
    });


    const openStepsApproval = (type) => {
        setIsOpenStepsApproval({
            ...isOpenStepsApproval,
            isOpen: true,
            type,
        });
    }


    const submitForm = async (e) => {
        e.preventDefault();
        alert("submitted");
    }


    return ( 
        <div>


            <DynamicHeadTag
                headerText="Approval Form | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />


            <AddStepsApproval
                isOpen={isOpenStepsApproval.isOpen}
                setIsOpen={(e) => setIsOpenStepsApproval({...isOpenStepsApproval, isOpen: e})}
                type={isOpenStepsApproval.type}
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 border-b">
                <SettingsTab />
            </div>


            <div className="mt-6 lg:flex items-center">
                <div className="w-full lg:w-1/2">
                    <div className="flex items-center font-medium text-lg">
                        <BackButtonPage />
                        Back
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3">
                    <button type="button" className="btn btn-md btn-ep-primary">
                        Create workflow
                    </button>
                    <button type="button" onClick={goBack} className="btn btn-md btn-transparent-primary">
                        Cancel
                    </button>
                </div>
            </div>

            
            <form onSubmit={submitForm} className="mt-6">
                <div className="section-title">
                    Create Approval Workflow
                </div>

                <div className="mt-6 box">
                    <div className="max-w-xl">

                        <Input type="text" label="Name of Workflow" placeholder="Name of role" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
                        
                        <SelectInput
                            label="Select workflow type"
                            value={form.type}
                            onChange={(e) => setForm({...form, type: e.target.value})}
                        >
                            <option value="">Select workflow type</option>
                        </SelectInput>
                        
                        <hr className="mt-6 mb-8 !border-gray-200" />

                        <div className="section-title">
                            Workflow steps and approvals
                        </div>
                        
                        <div className="mt-4 pb-4 flex w-full h-full">
                            <div className="mr-6 flex-col">
                                <div className="mt-2 w-3 h-3 flex rounded-full bg-[#89b5a7]"></div>
                                <div className="w-1 h-full mt-1.5 mx-auto bg-[#d2d5da]"></div>
                            </div>
                            <div className="flex-grow pb-4">
                                <div className="flex items-center text-ep-primary font-medium">
                                    Initiators
                                    <IconInformationOutline
                                        className="w-4 ml-2"
                                        data-tip
                                        data-for="initiators"
                                    />
                                    <ReactToolTip id="initiators" className="tooptip-size max-w-[250px]">
                                        Initiators are users that can start the process
                                    </ReactToolTip>
                                </div>
                                <div>

                                    <div className="p-4 pb-1 mt-4 md:ml-6 flex flex-wrap items-center border rounded">
                                        <div className="w-max mr-3 mb-3 border border-black rounded px-3 py-1.5 my-auto flex space-x-3 items-center justify-between">
                                            <div>
                                                Oladele Soyemi
                                            </div>
                                            <div onClick={() => {}} className="h-full p-1 ml-2 flex hover:bg-red-500 rounded-md group cursor-pointer">
                                                <IconsTimes className="w-3 h-3 m-auto group-hover:svg-fill-white" />
                                            </div>
                                        </div>

                                        <div onClick={() => openStepsApproval("initiator")} className="w-max mr-3 mb-3 text-ep-primary font-medium border border-transparent hover:bg-[#F4F4F4] rounded px-3 py-1.5 my-auto flex items-center cursor-pointer">
                                            <IconPlus className="w-3 h-3 mr-2 svg-fill-primary" />
                                            Add new initiator
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                        <div className="mt-2 pb-4 flex w-full h-full">
                            <div className="mr-6 flex-col">
                                <div className="mt-2 w-3 h-3 flex rounded-full bg-[#89b5a7]"></div>
                                <div className="w-1 h-full mt-1.5 mx-auto bg-[#d2d5da]"></div>
                            </div>
                            <div className="flex-grow pb-4">
                                <div className="flex items-center text-ep-primary font-medium">
                                    Collaborator(s)
                                    <IconInformationOutline
                                        className="w-4 ml-2"
                                        data-tip
                                        data-for="collaborators"
                                    />
                                    <ReactToolTip id="collaborators" className="tooptip-size max-w-[250px]">
                                        Collaborators are users that can view and make comments to the request
                                    </ReactToolTip>
                                </div>
                                <div>

                                    <div className="p-4 pb-1 mt-4 md:ml-6 flex flex-wrap items-center border rounded">
                                        <div className="w-max mr-3 mb-3 border border-black rounded px-3 py-1.5 my-auto flex space-x-3 items-center justify-between">
                                            <div>
                                                Oladele Soyemi
                                            </div>
                                            <div onClick={() => {}} className="h-full p-1 ml-2 flex hover:bg-red-500 rounded-md group cursor-pointer">
                                                <IconsTimes className="w-3 h-3 m-auto group-hover:svg-fill-white" />
                                            </div>
                                        </div>

                                        <div onClick={() => openStepsApproval("collaborator")} className="w-max mr-3 mb-3 text-ep-primary font-medium border border-transparent hover:bg-[#F4F4F4] rounded px-3 py-1.5 my-auto flex items-center cursor-pointer">
                                            <IconPlus className="w-3 h-3 mr-2 svg-fill-primary" />
                                            Add new collaborator
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                        <div className="mt-2 pb-4 flex w-full h-full">
                            <div className="mr-6 flex-col">
                                <div className="mt-2 w-3 h-3 flex rounded-full bg-[#89b5a7]"></div>
                                {/* <div className="w-1 h-full mt-1.5 mx-auto bg-[#d2d5da]"></div> */}
                            </div>
                            <div className="flex-grow pb-4">
                                <div className="flex items-center text-ep-primary font-medium">
                                    Approver(s)
                                    <IconInformationOutline
                                        className="w-4 ml-2"
                                        data-tip
                                        data-for="approvers"
                                    />
                                    <ReactToolTip id="approvers" className="tooptip-size max-w-[250px]">
                                        Approvers are users that can either approve or reject a request
                                    </ReactToolTip>
                                </div>
                                <div>

                                    <div className="p-4 pb-1 mt-4 md:ml-6 flex flex-wrap items-center border rounded">
                                        <div className="w-max mr-3 mb-3 border border-black rounded px-3 py-1.5 my-auto flex space-x-3 items-center justify-between">
                                            <div>
                                                Oladele Soyemi
                                            </div>
                                            <div onClick={() => {}} className="h-full p-1 ml-2 flex hover:bg-red-500 rounded-md group cursor-pointer">
                                                <IconsTimes className="w-3 h-3 m-auto group-hover:svg-fill-white" />
                                            </div>
                                        </div>

                                        <div onClick={() => openStepsApproval("approver")} className="w-max mr-3 mb-3 text-ep-primary font-medium border border-transparent hover:bg-[#F4F4F4] rounded px-3 py-1.5 my-auto flex items-center cursor-pointer">
                                            <IconPlus className="w-3 h-3 mr-2 svg-fill-primary" />
                                            Add new approver
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </form>

        </div>
    )
}


const AddStepsApproval = (props) => {
    const {isOpen, setIsOpen, type} = props;


    const [form, setForm] = useState({
        memberType: "",
        member: "",
    })


    const prefix = (e) => {
        if (e === "collaborator"){
            return "a";
        }
        return "an";
    }


    const submitForm = async (e) => {
        e.preventDefault();
    }

    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-12">
                <div className="page-title">
                    Add {type}
                </div>
                <div className="mt-2 text-fade-2">
                    Select {prefix(type)} {type} from your team member list or choose a user role as {type}s
                </div>

                <div className="mt-10">

                    <div>
                        <Checkbox
                            type="radio"
                            label={<div>Use Team Members list</div>}
                            checked={form.memberType === "members"}
                            onChange={(e) => setForm({...form, memberType: "members", member: ""})}
                        />
                        <div className={`mt-3 pt-3 px-4 pb-0 border border-gray-100 rounded-md ${form.memberType !== "members" ? "opacity-40":""}`}>
                            <SelectInput label="Team Members" value={form.member} onChange={(e) => setForm({...form, member: e.target.value})} disabled={form.memberType !== "members"}>
                                <option value="">Select</option>
                                <option value="dele">Oladele Soyemi</option>
                                <option value="user">User 2</option>
                            </SelectInput>
                        </div>
                    </div>

                    <hr className="my-6 !border-gray-200" />

                    <div>
                        <Checkbox
                            type="radio"
                            label={<div>Use Team Roles</div>}
                            checked={form.memberType === "roles"}
                            onChange={(e) => setForm({...form, memberType: "roles", member: ""})}
                        />
                        <div className={`mt-3 pt-3 px-4 pb-0 border border-gray-100 rounded-md ${form.memberType !== "roles" ? "opacity-40":""}`}>
                            <SelectInput label="Team Members" value={form.member} onChange={(e) => setForm({...form, member: e.target.value})} disabled={form.memberType !== "roles"}>
                                <option value="">Select</option>
                                <option value="finance">Finance Managers</option>
                                <option value="other">Role 2</option>
                            </SelectInput>
                        </div>
                    </div>

                </div>

                <div className="mt-10 flex space-x-4">
                    <Maybe condition={form.memberType !== "" && form.member !== ""}>
                        <button type="submit" className="btn btn-ep-primary">
                            Add {type}
                        </button>
                    </Maybe>

                    <Maybe condition={form.memberType === "" || form.member === ""}>
                        <button type="submit" className="btn text-white bg-[#748094]">
                            Add {type}
                        </button>
                    </Maybe>

                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary">
                        Cancel
                    </button>
                </div>
            </form>
        </FormDrawer>
    )
}


export default Form;